/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CommentRectTextIcon16Light } from './CommentRectTextIcon16Light';
import { CommentRectTextIcon16Regular } from './CommentRectTextIcon16Regular';
import { CommentRectTextIcon16Solid } from './CommentRectTextIcon16Solid';
import { CommentRectTextIcon20Light } from './CommentRectTextIcon20Light';
import { CommentRectTextIcon20Regular } from './CommentRectTextIcon20Regular';
import { CommentRectTextIcon20Solid } from './CommentRectTextIcon20Solid';
import { CommentRectTextIcon24Regular } from './CommentRectTextIcon24Regular';
import { CommentRectTextIcon24Solid } from './CommentRectTextIcon24Solid';
import { CommentRectTextIcon32Regular } from './CommentRectTextIcon32Regular';
import { CommentRectTextIcon64Regular } from './CommentRectTextIcon64Regular';
var sizes = {
    16: {
        light: CommentRectTextIcon16Light,
        regular: CommentRectTextIcon16Regular,
        solid: CommentRectTextIcon16Solid,
    },
    20: {
        light: CommentRectTextIcon20Light,
        regular: CommentRectTextIcon20Regular,
        solid: CommentRectTextIcon20Solid,
    },
    24: {
        regular: CommentRectTextIcon24Regular,
        solid: CommentRectTextIcon24Solid,
    },
    32: {
        regular: CommentRectTextIcon32Regular,
    },
    64: {
        regular: CommentRectTextIcon64Regular,
    },
};
export var CommentRectTextIcon = forwardRef('CommentRectTextIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
